export default {
  MENU_BTN_ARIA_LABEL: 'תפריט',
  BACK_BTN_ARIA_LABEL: 'חזור אחורה',
} as const;
